import { useMutation } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'
import { MutationOptions, queryClient } from '@/api/react-query'
import { customerApplicationsQueryKey } from '@/api/financial/customer/list-customer-applications'
import { CreditProductName } from '@/types/customer-context'

type CreateApplicationBody = {
  product_name: CreditProductName
}

type CreateApplicationResponse = {
  key: string
}

async function createApplication(body: CreateApplicationBody) {
  const response = await httpClient(
    'financial',
  ).post<CreateApplicationResponse>('/v1/application', body)

  return response.data
}

function invalidateCreditQueries() {
  queryClient.invalidateQueries({ queryKey: ['customer-context', 'financial'] })
  queryClient.invalidateQueries({ queryKey: customerApplicationsQueryKey })
}

export function useCreateApplication(
  options?: MutationOptions<CreateApplicationResponse, CreateApplicationBody>,
) {
  const { onSuccess, ...rest } = options ?? {}

  return useMutation({
    mutationFn: createApplication,
    ...rest,
    onSuccess: (...args) => {
      invalidateCreditQueries()
      onSuccess?.(...args)
    },
  })
}
